export default function LockIcon({ color = "#9CA3AF" }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3334 4.99998L11.8667 6.53331C11.9913 6.65547 12.1589 6.72389 12.3334 6.72389C12.5079 6.72389 12.6754 6.65547 12.8 6.53331L14.2 5.13331C14.3222 5.00869 14.3906 4.84115 14.3906 4.66665C14.3906 4.49214 14.3222 4.3246 14.2 4.19998L12.6667 2.66665M14 1.33331L7.60004 7.73331M8.66671 10.3333C8.66671 12.3584 7.02508 14 5.00004 14C2.975 14 1.33337 12.3584 1.33337 10.3333C1.33337 8.30827 2.975 6.66665 5.00004 6.66665C7.02508 6.66665 8.66671 8.30827 8.66671 10.3333Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
